export const HOME_IMAGES = {
  heroBackground: "/images/heroBackground.jpg",
  heroMain: "/images/heroMain.jpg",
  heroSecondary: "/images/heroSecondary.jpg",
  showcase: {
    consoles: "/images/showcase-consoles.jpg",
    smartphones: "/images/showcase-smartphones.jpg",
    cases: "/images/showcase-cases.jpg",
    accessories: "/images/showcase-accessories.jpg",
  },
  products: {
    iphone15: "/images/product-iphone15.jpg",
    ps5: "/images/product-ps5.jpg",
    headset: "/images/product-headset.jpg",
    dualsense: "/images/product-dualsense.jpg",
    galaxy: "/images/product-galaxy.jpg",
    keyboard: "/images/product-keyboard.jpg",
  },
} as const
